import {API} from '../../Services';

async function StoreOnlineCatsData(merchantId,catId){
    let mallId= localStorage.getItem('mallId');
    let token =  localStorage.getItem('token');
    return API.get(`/shop/${merchantId}/product_category_public/?parent__uid=${catId}`
        );
}



export {StoreOnlineCatsData}
